import React from 'react';

function Contact() {
  return (
    <div id="contact" style={{ marginTop: '20px' }}>
      <h2>Contact Me</h2>
      <p>联系方式。</p>
    </div>
  );
}

export default Contact;
